import { ICompanyRegistrationRequest } from '@okcargo-apps/shared-domain';
import {
  CompanyRegistrationCompanyFormPayload,
  CompanyRegistrationUserFormPayload,
} from './company-registration-forms.model';

export function mapFormsToCompanyRegistrationRequest(
  company: CompanyRegistrationCompanyFormPayload,
  user: CompanyRegistrationUserFormPayload,
): ICompanyRegistrationRequest {
  return {
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    phone: user.phone,
    companyTaxId: company.companyTaxId,
    companyName: company.companyName,
    companyStreet: company.companyStreet,
    companyPostalCode: company.companyPostalCode,
    companyCity: company.companyCity,
    companyCountryCode: company.companyCountryCode,
    token: '',
    privacyPolicyAccepted: user.privacyPolicyAccepted,
    termsAndConditionsAccepted: user.termsAndConditionsAccepted,
    source: '',
    medium: '',
    campaign: '',
    content: '',
    isCarrier: company.isCarrier,
    isShipper: company.isShipper,
  };
}
